import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AccordionItemClass } from '../accordion_item';
import { RedirectService } from '../../../../../shared/services/redirect.service';
import { TranslateService } from '@ngx-translate/core';
import { REDCRSS_EVENTS } from '../../../../../shared/services/constants/redcross_evemts';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';

@Component({})
export abstract class AccordionContentComponent implements OnInit {
  @Output() openNextItem: any = new EventEmitter();

  constructor(protected item: AccordionItemClass,
              protected redirectService: RedirectService,
              protected redcrossService: AnalyticsTrackingProvider,
              protected translate: TranslateService) {}

  trackCopyCode() {
   this.redcrossService.track(REDCRSS_EVENTS.CTA_CLICK,
     {
       ctaType: 'Button',
       ctaText: 'Copy Code',
       ctaLocation: this.translatedTitle(this.item)
     });
  }

  openNext(item) {
    this.redcrossService.track(REDCRSS_EVENTS.CTA_CLICK,
      {
        ctaType: 'Button',
        ctaText: 'Next',
        ctaLocation: this.translatedTitle(this.item)
      });
    this.openNextItem.emit(item);
  }

  ngOnInit() {

  }

  protected translatedTitle(item: AccordionItemClass) {
    return this.translate.instant(item.getTitle());
  }
}
